import { render, staticRenderFns } from "./MdhealtFormHeader.vue?vue&type=template&id=32b388d8"
import script from "./MdhealtFormHeader.vue?vue&type=script&lang=js"
export * from "./MdhealtFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports